import React from "react";
import Link from "next/link";

import { usePathname } from "next/navigation";

import styling from "./BlogNavigation.module.scss";

const BlogNavigation = () => {
  const currentRoute = usePathname();

  return (
    <div className={`${styling.blogNavigation}`}>
      <nav>
        <div>
          <ul>
            <li>
              <Link
                href="/blog"
                className={
                  currentRoute === "/blog"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                All Articles
              </Link>
            </li>
            <li>
              <Link
                href="/blog/frontend-articles"
                className={
                  currentRoute === "/blog/frontend-articles"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                Frontend
              </Link>
            </li>
            <li>
              <Link
                href="/blog/backend-articles"
                className={
                  currentRoute === "/blog/backend-articles"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                Backend
              </Link>
            </li>
          </ul>
          <ul>
            <li>
              <Link
                href="/blog/fullstack-articles"
                className={
                  currentRoute === "/blog/fullstack-articles"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                Fullstack
              </Link>
            </li>
            <li>
              <Link
                href="/blog/tech-trend-articles"
                className={
                  currentRoute === "/blog/tech-trend-articles"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                Tech Trends
              </Link>
            </li>
            <li>
              <Link
                href="/blog/motivational-articles"
                className={
                  currentRoute === "/blog/motivational-articles"
                    ? styling.activeLink
                    : styling.nonActiveLink
                }
              >
                Motivations
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default BlogNavigation;
